import { render, staticRenderFns } from "./Omir.vue?vue&type=template&id=1f09bca5"
import script from "./Omir.vue?vue&type=script&lang=ts"
export * from "./Omir.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports